import pickXApi from "../pickX.api";

export const handleWsRollingPrizeChanged = (dispatch, payload) => {
    dispatch(
        pickXApi.util.updateQueryData(
            'getRollingPrize',
            { currency: payload.Currency,
                wager: payload.Wager,
                sportId: payload.SportId,
                payoutModel: payload.PayoutModel },
            (draft) => {
                draft.RollingAmount = payload.RollingAmount;
            }
        )
    );
}